import { createAuthClient } from 'better-auth/react';

import { APP_NAME } from '@fade/shared';

/**
 * Better Auth React client. Cookies are sent automatically with `credentials: 'include'`.
 */
export const authClient = createAuthClient({
  baseURL: window.location.origin,
  fetchOptions: {
    credentials: 'include',
  },
});

export const { signIn, signUp, signOut, useSession } = authClient;

export const AUTH_APP_NAME = APP_NAME;